(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemonier-instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gemonier-instagram')) {
    customElements.define('gemonier-instagram', class extends HTMLElement {
      connectedCallback() {
        const feed = this.querySelector('.gm-instagram__feed');
        if (!feed) return;
        this.updateFeed = () => {
          const ready = [...feed.querySelectorAll('img, video, iframe')].some(media => {
            if (media.tagName === 'IMG') return Boolean(media.getAttribute('src') || media.getAttribute('srcset') || media.getAttribute('data-src') || media.getAttribute('data-srcset'));
            return Boolean(media.getAttribute('src') || media.querySelector('source[src]'));
          });
          this.toggleAttribute('data-feed-ready', ready);
        };
        this.observer = new MutationObserver(this.updateFeed);
        this.observer.observe(feed, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });
        feed.addEventListener('load', this.updateFeed, true);
        feed.addEventListener('error', this.updateFeed, true);
        this.updateFeed();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        const feed = this.querySelector('.gm-instagram__feed');
        feed?.removeEventListener('load', this.updateFeed, true);
        feed?.removeEventListener('error', this.updateFeed, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
